import styled from 'styled-components';
import { themeColor } from '@hud/web-components/theme/colors';
import { mdLight, xxlRegular } from '@hud/web-components/theme/typography';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: 5px;

  svg[aria-label='languages.java'] {
    position: relative;
    top: -1px;
  }
`;

const Subtitle = styled.div`
  ${mdLight};
  color: ${themeColor('textTertiary')};
  margin-bottom: 5px;
`;

const Title = styled.div`
  ${xxlRegular};
  color: ${themeColor('textPrimary')};
  display: flex;
  gap: 8px;
`;

const Description = styled.div`
  ${mdLight};
  color: ${themeColor('textPrimary')};
`;

const Body = styled.div`
  flex: 1;
  padding-top: 32px;
  padding-bottom: 16px;
  scrollbar-width: thin;
  scrollbar-color: rgba(255, 255, 255, 0.1) transparent;
`;

const Info = styled.div`
  ${mdLight};
  color: ${themeColor('textTertiary')};
`;

const Footer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;

const IconContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

export const StepStyles = {
  Container,
  Subtitle,
  IconContainer,
  Title,
  Description,
  Body,
  Info,
  Footer,
};
